/* ========================================================================== 
   Section : Video carousel
   Fichier : assets/video-carousel.js
   Rôle : volontairement minimal. Le défilement fluide est géré en CSS pour
   garantir le fonctionnement même dans l’éditeur de thème Shopify.
   ========================================================================== */

(() => {
  document.addEventListener('shopify:section:load', (event) => {
    const carousels = event.target.querySelectorAll('.video-carousel__track');

    carousels.forEach((track) => {
      track.style.animation = 'none';
      window.requestAnimationFrame(() => {
        track.style.animation = '';
      });
    });
  });
})();
